import $Api from '../../api/request';
import {asyncRoutes, resetRouter} from '../../router';
import {getCookie} from '../../util/util';
import {SEt_OPEN_PAGE_MODE} from "@/store/mutations";

// 用户登录
export const setLogin = ({commit}, data) => {
    const {userName, passWord, isAutoLogin} = data;
    return new Promise((resolve, reject) => {
        $Api.login({
            userName: userName.trim(),
            passWord: passWord,
            isAutoLogin: isAutoLogin
        })
            .then((response) => {
                const {success} = response;
                commit('SET_LOGIN', success);
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

// 退出登录
export const loginout = ({commit}) => {
    return new Promise((resolve, reject) => {
        $Api.logout()
            .then(() => {
                commit('SET_LOGIN', false);
                commit('SET_USERINFO', {roles: []});
                resetRouter();

                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    });
};

// 拉取用户信息
export const getUserInfo = ({commit}) => {
    return new Promise((resolve, reject) => {
        const loginCookie = getCookie('logincookie');
        let loginInfo = loginCookie
            ? JSON.parse(loginCookie)
            : {
                //   danweiguid: '28b49ae6-4496-4623-bc8c-2a950578f96f',
                //   stafftype: '1',
                //   danweiname: '54ix546b55S15Yqo6L2m5pyJ6ZmQ5YWs5Y+4',
                //   userguid: '17613e79-9fe4-4a90-aab7-dace84c93a4d',
                //   username: '6ZuB6bij5rKZ5rSy',
                //   bqusername: '6Zif6ZW/5b+r5pKk',
                //   phone: '18951132085',
                //   logourl:
                //       '/unity-web/rest/unityuser/common/v1/getcontent?attachguid=7c87ff77-d855-4262-8eb6-bb5b71c94f66'
            };

        if (!Object.keys(loginInfo).length && window.Config.testloginInfo) {
            loginInfo = window.Config.testloginInfo;
        }

        if (!Object.keys(loginInfo).length) {
            window.location.href = window.Config.loginUrl;
        }

        $Api.getUserInfo({
            userguid: loginInfo.userguid || '',
            phone: loginInfo.phone || ''
        })
            .then((userData) => {
                if (!userData) {
                    reject('Verification failed, please Login again.');
                }

                let vips = [];
                userData.asset.forEach((item) => {
                    if (item.assettype === 'MATERV') {
                        item.subitemlist.forEach((vip) => {
                            if (vip.subitem.indexOf('CVIP') > -1) {
                                vip.type = 'CVIP';
                                vip.title = '尊享会员';
                                vip.equitys = [
                                    {
                                        label: '付费素材',
                                        value: 1,
                                        unit: '万+'
                                    },
                                    {
                                        label: '素材折扣',
                                        value: 8,
                                        unit: '折'
                                    },
                                    {
                                        label: '免费浏览',
                                        value: 10,
                                        unit: '页'
                                    }
                                ];
                            } else {
                                vip.type = 'SVIP';
                                vip.title = '超级会员';
                                vip.equitys = [
                                    {
                                        label: '付费素材',
                                        value: 1,
                                        unit: '万+'
                                    },
                                    {
                                        label: '素材折扣',
                                        value: 6,
                                        unit: '折'
                                    },
                                    {
                                        label: '免费浏览',
                                        value: 10,
                                        unit: '页'
                                    }
                                ];
                            }

                            // 检查会员是否过期
                            const now = new Date().getTime();
                            const expireDate = new Date(vip.expiredate).getTime();
                            if (expireDate > now) {
                                vips.push(vip);
                            }
                        });
                    }
                });

                let userInfo = {
                    userguid: userData.basic.userguid,
                    name: userData.basic.username,
                    avatar: userData.basic.headpicurl, // 头像
                    account: userData.basic.phone, // 账号
                    phone: userData.basic.phone, // 手机号
                    isVip: vips.length > 0, // 是否vip
                    vips, // 已开通会员
                    isMaster: 0, // 是否达人

                    collection: 0, // 我的收藏
                    resources: 0, // 我的资源

                    todayEarnings: 0, // 今日收益
                    cumulativeIncome: 0, // 累计收益
                    accountBalance: 0, // 账户余额
                    materialNum: 0 // 素材数量
                };

                // const { roles } = response

                // roles must be a non-empty array
                // if (!roles || roles.length <= 0) {
                //     reject('getInfo: roles must be a non-null array!')
                // }

                Promise.all([
                    $Api.getOperationStatistics({
                        userguid: userInfo.userguid
                    }),
                    $Api.getIncomeStatistics({
                        relationguid: userInfo.userguid
                    }),
                    $Api.getMasterInfo({
                        userguid: userInfo.userguid,
                        shopguid: '',
                        ishomepage: '1'
                    })
                ]).then((data) => {
                    userInfo.collection = data[0].total_collectednum;
                    userInfo.resources = data[0].total_payednum;

                    userInfo.todayEarnings = data[1].totalincome_today;
                    userInfo.cumulativeIncome = data[1].totalincome_all;
                    userInfo.materialNum = data[1].materialnum;
                    userInfo.accountBalance = data[1].withdrawcash_tobe;

                    if (data[2].publisher && data[2].publisher.auditstatus == 3) {
                        userInfo.isMaster = 1;
                    } else {
                        userInfo.isMaster = 0;
                    }
                    commit('SET_USERINFO', userInfo);
                    resolve(userInfo);
                });
            })
            .catch((error) => {
                reject(error);
            });
    });
};

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some((role) => route.meta.roles.includes(role));
    } else {
        return true;
    }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
    const res = [];

    routes.forEach((route) => {
        const tmp = {...route};
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles);
            }
            res.push(tmp);
        }
    });

    return res;
}

// 根据角色添加路由
export const generateRoutes = ({commit}, roles) => {
    return new Promise((resolve) => {
        let accessedRoutes;
        // admin 用户拥有所有动态权限的路由
        if (roles.includes('admin')) {
            accessedRoutes = asyncRoutes || [];
        } else {
            accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
        }
        commit('SET_ROUTES', accessedRoutes);
        resolve(accessedRoutes);
    });
};

export function openMembershipDialog({commit}, data) {
    let materialguid = '';
    let promocode = '';
    let issetdefault = false;

    if (typeof data === 'object' && data !== null) {
        materialguid = data.materialguid || '';
        promocode = data.promocode || '';
        issetdefault = data.issetdefault || false;
    } else {
        materialguid = data || '';
    }

    commit('SET_MEMBERSHIP_DIALOG', {
        show: true,
        materialguid: materialguid,
        promocode: promocode,
        issetdefault: issetdefault
    });
}

export function closeMembershipDialog({commit}) {
    commit('SET_MEMBERSHIP_DIALOG', {
        show: false,
        materialguid: '',
        promocode: '',
        issetdefault: false
    });
}

export function openMaterialDetailDialog({commit}, data) {
    data += '';
    commit('SET_MATERIAL_DETAIL_DIALOG', {
        show: true,
        materialguid: data || ''
    });
}

export function closeMaterialDetailDialog({commit}) {
    commit('SET_MATERIAL_DETAIL_DIALOG', {
        show: false,
        materialguid: ''
    });
}


export function setPlatform({commit}, data) {
    commit('SEt_PLATFORM',data || 'D05');  // DesktopApp
}
